import { createSelector } from 'reselect';

import type { IRootState } from 'store/types';

export const selectCreationStatus = createSelector(
  (state: IRootState) => state,
  (state) => state.events.create,
);
